// extracted by mini-css-extract-plugin
module.exports = {"Featuretwoo":"Featuretwoo_Featuretwoo__vqjVf"};